<template>
  <div class="listing-page">
    <header class="header">
      <div class="row align-center">
        <div class="columns small-12 medium-8 text-center">
          <h1>{{ title }}</h1>
          <p>{{ description }}</p>
        </div>
      </div>
    </header>
    <section class="row">
      <div class="columns small-12">
        <ul class="row block-grid small-up-2 medium-up-3 align-center">
          <li v-for="curriculum in curriculums" :key="curriculum.slug">
            <div class="card">
              <figure class="card-img">
                <nuxt-link
                  :to="
                    localePath(
                      (curriculum.name === '$config.curriculumV9' ? '/' : '/curriculums/') +
                        curriculum.slug +
                        '/'
                    )
                  "
                  title="Browse resource in this curriculum"
                >
                  <nuxt-img
                    :src="'/images/curriculums/' + curriculum.slug + '.png'"
                    :alt="curriculum.name"
                    width="1200"
                    height="629"
                    format="webp"
                  />
                </nuxt-link>
              </figure>
              <div class="card-content">
                <h3 class="heading-4 text-curriculum">Curriculum</h3>
                <h4 class="heading-3">
                  <nuxt-link
                    :to="
                      localePath(
                        (curriculum.name === '$config.curriculumV9' ? '/' : '/curriculums/') +
                          curriculum.slug +
                          '/'
                      )
                    "
                    title="Browse resource in this curriculum"
                  >
                    {{ curriculum.name }}
                  </nuxt-link>
                </h4>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="section row text-center">
      <div class="columns small-12">
        <div class="box">
          <h2>How do I search for resources in my region?</h2>
          <p v-if="location">
            You're currently browsing Teach Starter for
            <strong>{{ location.name }}</strong>
            and will see all resources relevant to the curriculum in that location.
          </p>

          <p>
            If this isn't correct, or you'd like to search for resources in another country,
            <button class="button-link" @click="toggleLocationSelectorModal(true)">
              update your location here
            </button>
            .
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* List of curriculums by country
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components:
 * @methods:
 */

import { mapGetters } from 'vuex';
import curriculumsList from '~/data/curriculums.json';

export default {
  name: 'CurriculumsIndex',
  data() {
    return {
      title: 'School Curriculums',
      description: 'Choose a school curriculum below to browse its learning areas and resources.',
      curriculums: curriculumsList[this.$i18n.locale],
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title + ' - Curriculum Aligned' },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$canonicalLink(this.$route),
    };
  },
  //nuxtI18n: false,
  computed: {
    ...mapGetters(['location']),
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
  methods: {
    toggleLocationSelectorModal(show) {
      this.$store.dispatch('toggleLocationSelectorModal', show);
    },
  },
};
</script>
<style scoped lang="scss">
@import '~/assets/scss/components/_card.scss';

.header {
  margin-top: $base-padding * 2;
}

.button-link {
  color: $color-link;
  text-decoration: underline;

  &:hover,
  &:focus {
    color: $color-link-hover;
  }
}
</style>
